import type { ReactNode } from "react";

export interface DockItem {
  id: string;
  label: string;
  icon: ReactNode;
  /** Contador en la esquina, si la ficha tiene algo que contar. */
  badge?: string;
  /** Encendida: la ficha se pinta en dorado. */
  active: boolean;
  onClick: () => void;
}

interface Props {
  items: DockItem[];
}

/**
 * El dock: las acciones que se toman desde cualquier sala, en fichas grandes abajo a
 * la derecha.
 *
 * Son TRES por diseño, y lo que no está no se olvidó:
 * · La tienda la abre el mostrador del Sweet, no un botón — es el servidor quien
 *   sabe que estás al lado, igual que con una puerta.
 * · El perfil y la cuenta viven en el carnet, arriba a la izquierda.
 * · El mapa es el campus mismo: se recorre cruzando puertas.
 * · Quién está en la sala se consulta de reojo, desde su propio disparador arriba a
 *   la derecha: es una CONSULTA, no una acción, y pedía la misma atención que "jugar".
 * Un botón para cada una de esas cosas sería un atajo que compite con el mundo, que
 * es justo lo que este juego no quiere.
 *
 * (Tuvo una CUARTA, VOLLEY, mientras el coliseo no tenía cancha. Se fue por donde se
 * fue la tienda: al partido se entra llegando a la mesa de la cancha.)
 *
 * AMIGOS no es "quién está aquí": es tu panel social, que va contigo por el campus.
 * Quién está en ESTA sala cambia al cruzar una puerta y por eso se consulta arriba, no
 * desde el dock. Un mundo donde "amigos" significara "los que tengo enfrente" no
 * tendría amigos.
 */
export function Dock({ items }: Props) {
  return (
    <nav className="dock" aria-label="Acciones">
      {items.map((item) => (
        <button
          key={item.id}
          className={`dock__ficha${item.active ? " dock__ficha--on" : ""}`}
          type="button"
          onClick={item.onClick}
          aria-pressed={item.active}
        >
          <span className="dock__icono">{item.icon}</span>
          <span className="dock__etiqueta">{item.label}</span>
          {item.badge && <span className="dock__cuenta">{item.badge}</span>}
        </button>
      ))}
    </nav>
  );
}
